<template>
  <div class="card-container">
    <div class="injury_card mb28 mr28" v-for="item in cardList" :key="item.id">
      <div class="injury_card_header">
        <img
          class="header_bg"
          src="@i/injury/injury_card_header_bg.png"
          :style="setBgColor(item)"
          alt=""
        />
        <div class="header_info">
          <h2 class="injury_position SysFText_OverontM">
            {{ !item.recure_date ? item["position"] : "恢复治疗" }}
          </h2>
          <!-- <div class="injury_date" v-if="!item.recure_date">
            {{ item.esimated_return_date + "天" }}
          </div> -->
        </div>
      </div>

      <div class="injury_card_center">
        <div class="injury_info">
          <span class="title" v-if="!item.recure_date">受伤日期</span>
          <span class="title" v-if="item.recure_date">治疗日期</span>
          <span class="AkrobatM date">{{ item.recure_date || item.date }}</span>
        </div>

        <div class="injury_info">
          <template v-if="!item.recure_date">
            <span class="title" v-if="!item.recure_date"> 受伤严重程度 </span>
            <injury-grade
              class="header_value"
              :grade="item.severity"
            ></injury-grade>
          </template>
          <template v-else-if="item.recure_date">
            <span class="title" v-if="item.recure_date">康复日期</span>
            <span class="AkrobatM">{{ item.recure_date }}</span>
          </template>
        </div>
      </div>
      <div class="injury_card_bottom">
        <div class="injury_card_bottom_name">
          <cl-avatar
            :src="item.updator_avatar"
            :width="22"
            :height="22"
            :round="true"
            class="mr8"
          ></cl-avatar>
          <span>{{ item["updator_name"] }}</span>
        </div>
        <div class="injury_card_bottom_time">
          {{ item.create_time }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import injuryGrade from "./injury-grade.vue";
export default {
  components: {
    injuryGrade,
  },
  props: ["cardList"],
  computed: {
    setBgColor() {
      return (item) => {
        let { type, recure } = item;
        let color = "#60BF52";
        if (recure) {
          color = "#60BF52";
        }
        if (!recure && !item.recure_date) {
          color = "#FF4437";
        }
        if (!recure && item.recure_date) {
          color = "#00CCC0";
        }
        let bg = `background-color:${color}`;
        return bg;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  margin-right: -24px;
  max-height: 650px;
  overflow: auto;
}
.injury_card {
  width: 260px;
  height: 160px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #f6f6f6;
  box-shadow: 0px 4px 4px 0px rgba(129, 129, 138, 0.08);
  cursor: pointer;
  .injury_card_header {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 40px;
    display: flex;
    box-sizing: border-box;
    color: #fff;
    .header_bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 41px;
    }
    .header_info {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f3f5f9;
      //   .injury_date {
      //     width: 45px;
      //     height: 36px;
      //     line-height: 36px;
      //     padding-right: 4px;
      //     text-align: right;
      //     background-image: url("~@/assets/images/cfa/injury-date.png");
      //     background-repeat: no-repeat;
      //   }
    }
  }
  .injury_position {
    padding-top: 6px;
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    padding-left: 16px;
  }
  .injury_card_center {
    padding: 8px 8px;
    height: 82px;
    border-bottom: 1px solid #f3f5f9;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    box-sizing: border-box;

    .injury_info {
      display: flex;
      margin-top: 8px;
      line-height: 17px;
      align-items: center;
      span {
        display: inline-block;
        color: #b7b7bf;
        font-size: 12px;
        &:nth-of-type(1) {
          margin-right: 16px;
        }
      }
      .date {
        font-size: 16px;
        color: #3a3a3a;
      }
    }
  }

  .injury_card_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    padding: 0 8px;
    &_name {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #9c9c9c;
    }
    &_time {
      font-family: AkrobatRegular;
      color: #b4b4bb;
      font-size: 14px;
    }
  }
}
.op {
  opacity: 0;
}
</style>
